import React from "react";
import { MessageBubble } from "../../styled/Chatbox";

export const MessageSelf = ({ text }) => {
    return <MessageBubble>{text}</MessageBubble>;
};

export const MessageBot = ({ text }) => {
    return <MessageBubble left="true">{text}</MessageBubble>;
};
  